import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { ReactComponent as ConfirmIcon } from '../../../assets/svg/ConfirmIcon.svg';
import { createNewSkupOblasti, updateNewSkupOblasti } from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import Loading from '../../../utils/Loading';
import MDEditor from '@uiw/react-md-editor';
import VisibleCheckBox from '../common/VisibleCheckBox';

type Inputs = {
    naziv: string;
    opis: string;
    redosled: number | undefined;
};

function AddSkupOblastiModal({ modalIsOpen, closeModal, kategorija, podkategorija, skupOblasti, reloadSkupOblastiList }: any) {
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(true);
    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        reset,
        control,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            naziv: '',
            opis: '',
            redosled: 0,
        },
    });

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root');
        }
    }, [modalIsOpen]);

    useEffect(() => {
        if (!!skupOblasti?.id) {
            setValue('naziv', skupOblasti.naziv);
            setValue('opis', skupOblasti.opis);
            setValue('redosled', skupOblasti.redosled);
            setVisible(skupOblasti?.visible);
        }
    }, [skupOblasti]);
    const onSubmit: SubmitHandler<Inputs> = async () => {
        if (!!skupOblasti?.id) updateSkupOblasti();
        else {
            createSkupOblasti();
        }
    };
    const createSkupOblasti = async () => {
        setLoading(true);
        let data: any = getValues();
        data.redosled = getValues('redosled')?.toString();
        data.podkategorijaId = podkategorija?.id;
        data.visible = visible;
        const resp = await createNewSkupOblasti(data);
        if (resp.status == 201) {
            reloadSkupOblastiList(podkategorija);
            notif('Uspešno ste kreirali novi skup oblasti');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };
    const updateSkupOblasti = async () => {
        setLoading(true);
        let data: any = getValues();
        data.id = skupOblasti?.id;
        data.redosled = getValues('redosled')?.toString();
        data.podkategorijaId = podkategorija?.id;
        data.visible = visible;
        const resp = await updateNewSkupOblasti(data);
        if (resp.status == 201) {
            reloadSkupOblastiList(podkategorija);
            notif('Uspešno ste izmenili skup oblasti');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };

    const changeVisibilty = () => {
        setVisible((prev) => !prev);
    };
    return (
        <ReactModal
            ariaHideApp={false}
            closeTimeoutMS={600}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {
                reset();
            }}
            onRequestClose={closeModal}
            className="no-scroll"
            style={{
                overlay: {
                    zIndex: 5,
                    backdropFilter: 'brightness(30%)',
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 600,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    height: '100%',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'auto',
                    paddingTop: 15,
                    paddingBottom: 15,
                },
            }}
        >
            <div className="   max-h-[600px] w-full  ">
                <div className="">
                    <form
                        className="col-span-2 flex flex-col items-center w-full bg-white px-[40px] py-[30px] rounded-[10px]"
                        onSubmit={handleSubmit(onSubmit)}
                        autoComplete="off"
                    >
                        <div className="flex flex-col w-full">
                            <label className="text-[16px] leading-5 text-black700 font-bold  ">Naziv skupa oblasti</label>
                            <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                                <input
                                    className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                    placeholder="Naziv skupa oblasti"
                                    {...register('naziv', {
                                        validate: {
                                            najduze: (value) => value.length < 100,
                                            obavezno: (value) => value.length > 0,
                                        },
                                    })}
                                />
                            </div>
                            <p className="text-redError text-[12px] leading-5 h-5 ">
                                <span>{errors.naziv?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''} </span>
                                <span>{errors.naziv?.type === 'najduze' ? 'Duzina ne sme prelaziti 100 karaktera' : ''}</span>
                            </p>
                        </div>
                        <div className="mt-4 w-full">
                            <div className="flex flex-row items-end justify-between gap-5">
                                <p
                                    className={`text-black font-semibold text-lg text-left ${errors.opis?.type === 'required' ? 'text-redError' : 'text-primaryViolet'}`}
                                >
                                    Opis skupa oblasti
                                </p>

                                <p className="text-redError font-medium text-lg  ">{errors.opis?.type === 'required' ? '* This field is required' : ''}</p>
                            </div>
                            <Controller
                                control={control}
                                name="opis"
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <MDEditor value={field.value} onChange={(value: any) => setValue('opis', value, { shouldValidate: true })} preview="edit" />
                                )}
                            />
                        </div>
                        <div className="flex flex-col w-full mt-5">
                            <label className="text-[16px] leading-5 text-black700 font-bold  ">Redosled skupa oblasti</label>
                            <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                                <input
                                    className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                    placeholder="Redosled skupa oblasti"
                                    type="number"
                                    {...register('redosled', {
                                        min: 0,
                                    })}
                                />
                            </div>
                            <p className="text-redError text-[12px]  leading-5 h-5 ">
                                <span>{errors.redosled?.type === 'min' ? 'Vrednost mora biti pozitivan broj!' : ''} </span>
                            </p>
                        </div>
                        <VisibleCheckBox label="Skup oblasti vidljiv" value={visible} toggleValue={changeVisibilty} />
                        <p className="text-redError text-[12px] leading-5 h-5 ">{!!errorMessage ? errorMessage : ''}</p>
                        <div className="w-full flex flex-row gap-5 justify-end">
                            <button
                                className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    closeModal();
                                }}
                            >
                                <p>Otkaži</p>
                            </button>
                            <button
                                type="submit"
                                className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                                disabled={loading}
                            >
                                {loading ? (
                                    <Loading size={25} />
                                ) : (
                                    <div className="w-full flex flex-row items-center justify-center gap-3">
                                        <ConfirmIcon />
                                        <p>Potvrdi</p>
                                    </div>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </ReactModal>
    );
}

export default AddSkupOblastiModal;
